import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/features',
    name: 'features',
    component: () =>
      import(/* webpackChunkName: "features" */ '../views/FeaturesView.vue'),
  },
  {
    path: '/nfse',
    name: 'nfse',
    component: () =>
      import(/* webpackChunkName: "nfse" */ '../views/NfsePageView.vue'),
  },
  {
    path: '/faq',
    name: 'faq',
    component: () =>
      import(/* webpackChunkName: "faq" */ '../views/FaqView.vue'),
  },
  {
    path: '/plans',
    name: 'plans',
    component: () =>
      import(/* webpackChunkName: "plans" */ '../views/PlansView.vue'),
  },
  {
    path: '/contact',
    name: 'contact',
    component: () =>
      import(/* webpackChunkName: "contact" */ '../views/ContactView.vue'),
  },
  {
    path: '/link-hub',
    name: 'link-hub',
    component: () =>
      import(/* webpackChunkName: "links" */ '../views/LinksView.vue'),
  },
  {
    path: '/terms',
    name: 'terms',
    component: () =>
      import(/* webpackChunkName: "terms" */ '../views/TermsView.vue'),
  },
  {
    path: '/privacy-police',
    name: 'privacy-police',
    component: () =>
      import(
        /* webpackChunkName: "privacyPolice" */ '../views/PrivacyPoliceView'
      ),
  },
  // External link (Login)
  {
    path: '/login',
    name: 'login',
    beforeEnter: () => {
      window.open('https://financeiro.janelaunica.com.br/#/login', '_blank')
    },
  },
  // External link (Register)
  {
    path: '/register',
    name: 'register',
    beforeEnter: () => {
      window.open('https://financeiro.janelaunica.com.br/#/registro', '_blank')
    },
  },
  {
    path: '/help',
    name: 'help',
    beforeEnter: () => {
      window.open('https://suporte.jufinanceiro.com', '_blank')
    },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  async scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    await new Promise((resolve) => setTimeout(resolve, 300))

    if (to.hash) {
      return new Promise((resolve) => {
        const findElAndCheckHeight = (
          selector,
          maxAttempts = 150,
          currentAttempt = 0
        ) => {
          const element = document.querySelector(selector)

          // If the element exists AND its content is loaded (height > placeholder height)
          if (element && element.scrollHeight > 401) {
            resolve({ el: selector, top: 116, behavior: 'smooth' })
            return
          }

          if (currentAttempt >= maxAttempts) {
            resolve({ top: 0, left: 0, behavior: 'smooth' }) // Fallback to top
            return
          }

          // Otherwise, wait and try again
          setTimeout(() => {
            findElAndCheckHeight(selector, maxAttempts, currentAttempt + 1)
          }, 20)
        }

        // Start polling
        findElAndCheckHeight(to.hash)
      })
    }

    return { top: 0, left: 0, behavior: 'smooth' }
  },
})

export default router
